module.exports = __webpack_public_path__ + "static/media/noimg-target.fe115a4c.svg";